import React from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { CreatorStarlingKey, RoleType } from '@/constants';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import {
  ArticleCard,
  ListPanel,
  SkeletonCardList,
} from '@/pages/Homepage/components';
import { useContent, UseContentOptions } from './index.ViewHook';
import NoContentPage from '@features/components/no-content-page';

interface ContentProps extends UseContentOptions {
  onItemClick?: (info: LearningInfo, index: number, pageNumber: number) => void;
}

export const Content = React.memo(({ type, onItemClick }: ContentProps) => {
  const { t } = useTranslation();
  const { item: bItem, fetch } = useContent({ type });

  if (!bItem) {
    return <NoContentPage className="mx-auto" />;
  }

  return (
    <ListPanel
      id={bItem.id}
      className="pl-8"
      header={
        <h3 className="text-p5 font-bold">
          {type === RoleType.Seller
            ? t('academy_content_role_seller')
            : t(CreatorStarlingKey)}
          : <span className="text-rubine-03">{bItem.name}</span>
        </h3>
      }
      pagination={{
        defaultPageSize: 12,
      }}
      fetch={fetch}
      renderItem={(item, index, pageNumber) => {
        return (
          <ArticleCard
            key={item.learning_id}
            poster={item.image}
            title={item.name}
            desc={item.description}
            views={item.views}
            tagInfo={item.tag_info}
            onClick={() => onItemClick?.(item, index, pageNumber)}
          />
        );
      }}
      renderLoading={(total, pageNumber, pageSize) => {
        return (
          <SkeletonCardList
            noTitle={true}
            size={
              total && pageSize * pageNumber > total
                ? total - pageSize * (pageNumber - 1)
                : pageSize
            }
          />
        );
      }}
    />
  );
});
